<div class="so-action-bar" [class.so-action-bar--top-corners]="showTopCorners()"
    [style.--so-action-bar-height.px]="height()">
    @if (message()) {
    <div class="so-action-bar-message" [class]="'so-action-bar-message--' + messageType()" role="alert"
        aria-live="polite">
        <mat-icon class="so-action-bar-message-icon">{{ messageIcon() }}</mat-icon>
        <span class="so-action-bar-message-text">{{ message() }}</span>
    </div>
    }
    <div class="so-action-bar-spacer"></div>
    <div class="so-action-bar-actions">
        <ng-content></ng-content>
    </div>
</div>
